import Message from "./src/index.js";
export default Message;